
/*
* 文件图标 fileType(前置方法 getFileSuffix 已处理小写)
* IconExcel,IconWord,IconPDF,IconVideo,IconImage
* */
import React from "react";
import { IconExcel,IconWord,IconPDF,IconVideo,IconImage,IconZip,IconDefault } from "@components/Icon/office";
import {isEmpty,trim,getFileSuffix} from '@utils/utils';
function renderFileType(file='',size=24){
    // let sType = '';
    const fileType = file?getFileSuffix(file):"";
    if(fileType.indexOf('xls')> -1||fileType.indexOf('xlsx')> -1){
        // sType = 'document';
        return <IconExcel size={size} />
    }else if(fileType.indexOf('pdf')> -1||fileType.indexOf('PDF')> -1){
        // sType = 'document';
        return <IconPDF size={size} />
        // }else if(fileType.indexOf('doc')> -1||fileType.indexOf('DOC')> -1){
        //     // sType = 'document';
    }else if(fileType.indexOf('jpeg')> -1||fileType.indexOf('jpg')> -1||fileType.indexOf('png')> -1||fileType.indexOf('bmp')> -1||fileType.indexOf('gif')> -1) {
        // return <IconImage />
        return <img src={file} alt={file} width={size} />
    }else if(fileType.indexOf('doc')> -1||fileType.indexOf('docx')> -1) {
        return <IconWord size={size} />
    }else if(fileType.indexOf('mp4')> -1||fileType.indexOf('flv')> -1) {
        return <IconVideo size={size} />
    }else if(fileType.indexOf('zip')> -1) {
        return <IconZip size={size} />
    }else return <IconDefault  size={size} />
}
export {
    renderFileType
}